import { render, staticRenderFns } from "./ZehnderLogo.vue?vue&type=template&id=3cabd180&scoped=true&"
var script = {}
import style0 from "./ZehnderLogo.vue?vue&type=style&index=0&id=3cabd180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cabd180",
  null
  
)

export default component.exports